import { render, staticRenderFns } from "./FavoriteAction.vue?vue&type=template&id=ebbb35d6"
import script from "./FavoriteAction.vue?vue&type=script&lang=ts"
export * from "./FavoriteAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports